export default "__VITE_ASSET__B7pC1e0B__"